import Link from 'next/link'
import { useRouter } from 'next/router'
import { Trans } from 'react-i18next'
import { useUtilHooks } from 'hooks/common/useUtilHooks'

const navilist = [
  {
    name: 'ID-NC-VF0503_WID0507', // SPL:保存レシピ
      url: '/recipe/index',
  },
  {
    name: 'ID-NC-VF0503_WID0508', // 公開レシピ
      url: '/recipe/published',
  },
  {
    name: 'ID-NC-VF0503_WID0509', // SPL:カメラ登録レシピ
      url: '/recipe/camera',
  },
  {
    name: 'ID-NC-VF0503_WID0510', // SPL:ニコンのレシピ
      url: '/recipe/release',
  },
]

// アンダーライン表示判定
const checkIsCurrent = (pathName, url) => {
  if (url == '/recipe/index') {
    return pathName.startsWith(url) || pathName.startsWith('/recipe/detail')
      ? ' is-current'
      : ''
  } else {
    return pathName.startsWith(url) ? ' is-current' : ''
  }
}

const LocalNavi = ({ authority }) => {
  // 2024/02/26 mantis-0031919 cookieを用いて権限フィールドを保存 start
  // const { t, Trans } = useUtilHooks()
  const { t, Trans, cookies } = useUtilHooks()
  // 2024/02/26 mantis-0031919 cookieを用いて権限フィールドを保存 end
  const router = useRouter()
  const pathName = router.pathname

  // 公開権限ありの場合のみ 公開レシピ を表示
  // 2024/02/26 mantis-0031919 cookieを用いて権限フィールドを保存 start
  const isAuthority = Number(cookies.authority)
  // 公開権限ありの場合のみ 公開レシピ を表示
  // const list = authority
  // ? navilist
  // : navilist.filter((navi) => !navi.url.endsWith('published'))
  const list = !!isAuthority
    ? navilist
    : navilist.filter((navi) => !navi.url.endsWith('published'))
  // 2024/02/26 mantis-0031919 cookieを用いて権限フィールドを保存 end
  // 2024/10/16 U2110SPEC-4262-お知らせ機能の追加改修 start
  const checkIsNew = (url) => {
    if (url == '/recipe/release') {
      return JSON.parse(cookies.isNew && cookies.isNew !== 'undefined' ? cookies.isNew : false) ? 'is-new' : ''
    }
  }
  // 2024/10/16 U2110SPEC-4262-お知らせ機能の追加改修 end
  return (
    <div className="o-local-navi" lang={t('ID-NC-VF0000_WID0000_0')}>
      <ul className="o-local-navi_list">
        {list.map((data, index) => {
          return (
            <li key={index}>
              <Link
                href={data.url}
                className={`o-local-navi_link js-touch-hover
                  ${checkIsNew(data.url)}
                  ${checkIsCurrent(pathName, data.url)}`}
              >
                {/* 2024/10/16 U2110SPEC-4262-お知らせ機能の追加改修 start */}
                {/* <a
                  className={`o-local-navi_link js-touch-hover ${checkIsCurrent(
                    pathName,
                    data.url
                  )}`}
                > */}

                  <Trans i18nKey={data.name} />

                {/* 2024/10/16 U2110SPEC-4262-お知らせ機能の追加改修 end */}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default LocalNavi
